import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { searchProgramsAdvanced } from '../../services/rpc';
import type { ProgramSearchResults, SearchFilters } from '../../types/rpc-contracts';

export interface ProgramSearchQueryOptions {
  filters: SearchFilters;
  enabled?: boolean;
}

export function useProgramSearch({ filters, enabled = true }: ProgramSearchQueryOptions) {
  return useQuery<ProgramSearchResults>({
    queryKey: ['program-search', filters],
    queryFn: async () => {
      return await searchProgramsAdvanced(filters);
    },
    enabled,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData
  });
}

export type ProgramSearchQuery = UseQueryResult<ProgramSearchResults, Error>;
